///<reference path="../../../../build/typings/index.d.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/configs/global.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/configs/http.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/models/model.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/directives/tab.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/filters/table.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/filters/platform.ts" />

///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/modules/models/module.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/modules/providers/repository.ts" />

///<reference path="components/menu.ts"/>
///<reference path="components/welcome.ts"/>
///<reference path="components/introduction.ts"/>
///<reference path="components/connect.ts"/>
///<reference path="components/finish.ts"/>

declare var wp: any;

module TotalPoll {
    import GlobalConfig = TotalCore.Common.Configs.GlobalConfig;
    import HttpConfig = TotalCore.Common.Configs.HttpConfig;

    export const onboarding = angular
        .module('onboarding', [
            'ngResource',
            'services.common',
            'filters.common',
            'directives.common',
            'services.modules',
            'components.totalpoll'
        ])
        .config(GlobalConfig)
        .config(HttpConfig)
        .value('ajaxEndpoint', window['totalpollAjaxURL'] || window['ajaxurl'] || '/wp-admin/admin-ajax.php')
        .value('namespace', 'TotalPoll')
        .value('OnBoarding', {
            data: {
                status: 'init',
                email: '',
                audience: 'other',
                usage: 'other',
                tracking: false,
                signup: false,
                newsletter: false
            },
            currentStep: 1,
            loading: false
        })
        .value('FeaturedModules', window['TotalpollFeaturedModules'] || {})
        .service('OnboardingService', ['OnBoarding', function (OnBoarding) {
            return {
                isStep: function (step: number) {
                    return OnBoarding.currentStep === step;
                },

                setStep: function (step: number) {
                    return OnBoarding.currentStep = step;
                },

                isFinished: function () {
                    return OnBoarding.currentStep === 4;
                },

                isStarted: function () {
                    return OnBoarding.currentStep > 1;
                },

                isLoading: function () {
                    return OnBoarding.loading;
                },

                previousStep: function () {
                    OnBoarding.currentStep--;
                },

                nextStep: function () {
                    OnBoarding.currentStep++;
                },

                isStepCompleted: function (step: number) {
                    return OnBoarding.currentStep > step;
                },

                store: function () {
                    OnBoarding.loading = true;

                    wp.ajax.send({
                        url: window['totalpollAjaxURL'],
                        data: {
                            action: 'totalpoll_onboarding',
                            onboarding: OnBoarding.data
                        }
                    }).always(function () {
                        OnBoarding.loading = false;
                        window.top.location.href = window['TotalpollDashboard'].url;
                    });

                },

                close: function () {
                    OnBoarding.data.status = 'skip';
                    this.store();
                },

                finish: function () {
                    OnBoarding.data.status = 'done';
                    this.store();
                }
            };
        }])
        .controller('MainController', ['$scope', 'OnboardingService', function ($scope, OnboardingService) {
            $scope.OnboardingService = OnboardingService;
        }]);
}
